import { LpcuDetailsLpcuDeviceGroup } from './lpcu-details-lpcu-device-group.model';

export class LpcuDetailsLpcu {

    constructor(json: any = null) {
        if (json) {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);

            if (json.DeviceGroup) this.DeviceGroup = new LpcuDetailsLpcuDeviceGroup(json.DeviceGroup);
            if (json.WhenCreated) this.WhenCreated = new Date(json.WhenCreated);
            if (json.WhenLastUpdated) this.WhenLastUpdated = new Date(json.WhenLastUpdated);
            if (json.WhenLastKnownCommunication) this.WhenLastKnownCommunication = new Date(json.WhenLastKnownCommunication);
        }
    }

    BootVersion: number;
    Description: string;
    DeviceGroup: LpcuDetailsLpcuDeviceGroup;
    FirmwareVersion: number;
    HardwareVersion: number;
    Id: number;
    IsRecognized: boolean;
    Name: string;
    OrdinalPosition: number;
    UId: string;
    WhenCreated: Date;
    WhenLastKnownCommunication: Date;
    WhenLastUpdated: Date;
    DeviceTypeId: Number;
    FixtureTypeId: number;
    DeviceType: any;
}
